import styled, { css } from 'styled-components'

const ResultItem = styled.div<{ $isActive: boolean }>`
  box-sizing: border-box;
  padding: 8px 10px;
  cursor: pointer;

  ${(p) =>
    p.$isActive &&
    css`
      background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey100};
    `}

  &:focus {
    outline: none;
    background-color: ${(p) => p.theme.uiKit.colors.global.grey.grey100};
  }
`

const ResultItemContent = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 8px;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    text-decoration: none;
  }
`

export const s = {
  ResultItem,
  ResultItemContent
}
